import { render, staticRenderFns } from "./TrainingSessionFormModal.vue?vue&type=template&id=087bfafc"
import script from "./TrainingSessionFormModal.vue?vue&type=script&lang=js"
export * from "./TrainingSessionFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports